import { useState } from "react";
import { FAQS } from "@/mocks/ecfMocks";
import { ChevronDown } from "lucide-react";

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section className="bg-white py-24 px-4 md:px-6">
      <div className="max-w-3xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="w-2 h-2 rounded-full bg-amber-400" />
            <span className="text-sm text-slate-500 font-medium">FAQ</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-3">
            Certificación, P12 y ambientes
          </h2>
          <p className="text-slate-500">
            Las preguntas más frecuentes de nuestros clientes técnicos y fiscales.
          </p>
        </div>

        {/* Accordion */}
        <div className="space-y-3">
          {FAQS.map((faq, i) => (
            <div
              key={i}
              className="border border-slate-100 rounded-xl overflow-hidden transition-all"
            >
              <button
                onClick={() => setOpenIdx(openIdx === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer hover:bg-slate-50 transition-colors"
              >
                <div className="flex items-center gap-3 flex-1">
                  <span className="text-xs font-bold text-slate-400 bg-slate-100 px-2.5 py-1 rounded-full whitespace-nowrap">
                    {faq.cat}
                  </span>
                  <span className="text-sm font-semibold text-slate-800">{faq.q}</span>
                </div>
                <ChevronDown
                  size={16}
                  className={`text-slate-400 flex-shrink-0 ml-4 transition-transform duration-200 ${openIdx === i ? "rotate-180" : ""}`}
                />
              </button>
              <div className={`accordion-content ${openIdx === i ? "open" : ""}`}>
                <div className="px-6 pb-5 pt-1">
                  <p className="text-sm text-slate-500 leading-relaxed">{faq.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <p className="text-slate-500 text-sm">
            ¿No encuentras tu respuesta?{" "}
            <a href="/contacto" className="text-blue-800 font-medium hover:underline cursor-pointer">
              Contáctanos directamente
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}